var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-title',[_vm._v("\n  "+_vm._s(_vm.service.title)+"\n  "),_c('v-spacer'),_vm._v(" "),(_vm.isOffer)?_c('price',{attrs:{"value":_vm.service.price}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a407cb5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/Header.vue
// module id = null
// module chunks = 